import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { TeachersAvailabilityApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export const useSpecialHoursDelete = (
  toast: ReturnType<typeof import("@/components/feedback").useToast>,
  teacherId: number,
) => {
  const accessToken = useAccessToken();
  const queryClient = useQueryClient();

  const { mutate, isPending, isSuccess, isError } = useMutation({
    mutationFn: async (id: number) => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(
        TeachersAvailabilityApi,
        accessToken,
      );
      return service.apiAvailabilitySpecialAppointmentHoursIdDelete({ id });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.SpecialHours, teacherId],
      });
      toast({
        title: "Special hours deleted",
        description: "Special hours have been deleted successfully!",
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    },
    onError: (error: any) => {
      const errorMessage =
        error instanceof Error
          ? error.message
          : "Failed to delete special hours";
      
      toast({
        title: "Error",
        description: errorMessage,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    },
  });

  return { mutate, isPending, isError, isSuccess };
};

